module.exports = __webpack_public_path__ + "static/step-4.e7a08ecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/server/step-4.png
// module id = 2571
// module chunks = 201946414757871